import { useSearchParams } from 'react-router-dom';
import { SchedulerFlow } from '@/components/scheduler/SchedulerFlow';

const BookingPage = () => {
  const [searchParams] = useSearchParams();
  const slug = searchParams.get('type') || undefined;

  return (
    <div className="pt-32 pb-20">
      <div className="section-container max-w-3xl">
        <div className="text-center mb-8">
          <h1 className="heading-2">
            Schedule a Meeting
          </h1>
          <p className="body-text mt-3">
            Choose a time that works for you. We'll send a calendar invite to confirm.
          </p>
        </div>
        <div className="border border-border rounded-xl bg-card overflow-hidden">
          <SchedulerFlow defaultSlug={slug} />
        </div>
      </div>
    </div>
  );
};

export default BookingPage;
